<template>
    <div>
        <div class="flex justify-center">
            <vs-card class="w-10/12 mt-5 shadow-lg card relative">
                <form ref="form" @submit.prevent="validate" class="flex flex-col items-center">
                    <div class="w-10/12 mt-10">
                        <h2 class="mb-4">Register</h2>

                        <vs-input
                            label="First Name"
                            v-validate="'required'"
                            name="first name"
                            v-model="details.firstName"
                            class="w-full"
                            placeholder="Enter first name"
                        />
                        <span class="text-danger text-sm" v-show="errors.has('first name')">{{
                            errors.first('first name')
                        }}</span>

                        <vs-input
                            label="Email"
                            v-validate="'required|email'"
                            name="email"
                            v-model="details.email"
                            class="w-full mt-4"
                            placeholder="Enter email address"
                        />
                        <span class="text-danger text-sm" v-show="errors.has('email')">{{
                            errors.first('email')
                        }}</span>

                        <vs-input
                            label="Password"
                            v-validate="'required|min:6'"
                            type="password"
                            name="password"
                            class="w-full mt-4"
                            v-model="details.password"
                            placeholder="Enter password"
                            ref="password"
                        />

                        <span class="text-danger text-sm" v-show="errors.has('password')">{{
                            errors.first('password')
                        }}</span>

                        <vs-input
                            label="Password"
                            v-validate="'required|confirmed:password'"
                            type="password"
                            name="password confirmation"
                            class="w-full mt-4"
                            v-model="details.passwordConfirm"
                            data-vv-as="password"
                            placeholder="Confirm password"
                            autocomplete="off"
                        />
                        <span
                            class="text-danger text-sm"
                            v-show="errors.has('password confirmation')"
                            >{{ errors.first('password confirmation') }}</span
                        >

                        <vs-select
                            color="#bcbdbe"
                            v-model="details.countryId"
                            label="Country"
                            class="w-full mt-4"
                            required
                            autocomplete
                        >
                            <vs-select-item
                                :value="item.countryID"
                                :text="item.countryName"
                                v-for="(item, index) in countries"
                                :key="index"
                            />
                        </vs-select>

                        <vs-input
                            disabled
                            label="Coupon Code"
                            v-validate="'required'"
                            name="coupon code"
                            class="w-full mt-4"
                            v-model="details.couponCode"
                            placeholder="Coupon Code"
                        />
                        <span class="text-danger text-sm" v-show="errors.has('coupon code')">{{
                            errors.first('coupon code')
                        }}</span>

                        <div v-show="showRedeemLink" class="text-sm pt-5">
                            Your email address already exists
                            <a
                                class="cursor-pointer font-bold"
                                @click="
                                    $router.push({
                                        name: 'redeem-existing',
                                        params: { couponCode: couponCode, email: details.email }
                                    })
                                "
                                >click here to redeem the coupon</a
                            >
                        </div>
                    </div>

                    <img
                        src="@/assets/images/croc.png"
                        height="250"
                        alt="Croc Image"
                        class="croc"
                    />
                    <div class="absolute bottom-0 z-50 flex flex-col items-center mb-5">
                        <button type="submit" class="sign-up w-7/12 h-12 z-50 mt-5">
                            Register
                        </button>
                        <p class="mt-5 text-center z-50">
                            BY CONTINUING, YOU AGREE TO OUR <br />
                            <b> PRIVACY POLICY </b> AND <b> TERMS &amp; CONDITIONS </b>
                        </p>
                    </div>
                </form>
            </vs-card>
        </div>
        <div id="turnstile-widget" data-size="flexible"></div>
    </div>
</template>

<script>
import { mapParams } from '@/plugins/mappers'
import Turnstile from '../../js/Turnstile'
import countries from '../countries'

export default {
    name: 'coupon-redemption-register',
    computed: {
        ...mapParams({
            couponCode: 'couponCode'
        })
    },
    watch: {
        couponCode: {
            handler(val) {
                if (val) {
                    this.details.couponCode = val
                }
            },
            immediate: true
        }
    },
    components: {},
    data() {
        return {
            showRedeemLink: false,
            countries: countries,
            passwordConfirm: null,
            details: {
                email: null,
                password: null,
                couponCode: null,
                firstName: null,
                countryId: 13
            }
        }
    },
    methods: {
        validate() {
            this.$validator.validateAll().then(async (result) => {
                if (result) {
                    try {
                        this.startLoad(this.$refs.form)
                        const token = window.turnstile.getResponse()
                        if (!token) {
                            this.notifyError('Error', 'Invalid Cloudfare Turnstile Token', 5000)
                            return
                        }

                        var turnstileVerification = await this.$api.auth.verifyTurnstile(token)

                        if (!turnstileVerification) {
                            this.notifyError(
                                'Error',
                                'Cloudfare Turnstile Verification Failed',
                                5000
                            )
                            return
                        }

                        await this.$store.dispatch('auth/register', {
                            firstName: this.details.firstName,
                            email: this.details.email,
                            password: this.details.password
                        })
                        var response2 = await this.$api.coupon.redeemCoupon({
                            couponCode: this.details.couponCode
                        })

                        // <<< GTM script for successful account registration
                        window.dataLayer.push({
                            event: 'Account Registration'
                        })
                        // ::v-deep

                        this.notifySuccess(
                            'Signed up successfully',
                            'You signed up successfully',
                            5000
                        )
                        this.$router.push('/success')
                    } catch (err) {
                        // console.error(err)
                        if (err.status == 409) {
                            // conflict user already exists
                            this.notifyError(
                                'Error',
                                `${this.details.email} is already registered.`,
                                5000
                            )
                            this.showRedeemLink = true
                        } else if (err.status == 403) {
                            // should never get here
                            this.notifyError(
                                'Error',
                                `Unable to find email ${this.details.email}, please try again.`,
                                5000
                            )
                        } else if (err.status == 400) {
                            this.notifyError('Coupon Error', `${err.data.title}`, 5000)
                        } else {
                            this.notifyError(
                                'Error',
                                `Something went wrong that shouldnt have.`,
                                5000
                            )
                        }
                    } finally {
                        this.endLoad(this.$refs.form)
                    }
                }
            })
        }
    },
    mounted() {
        const siteKey = process.env.VUE_APP_TURNSTILE_SITE_KEY
        const turnstileService = new Turnstile(siteKey)
        turnstileService.renderTurnstile('#turnstile-widget')
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Barlow:wght@300;400;500;600;700;800&family=Playfair+Display:wght@400;500;600;700;800&display=swap');
.croc {
    position: absolute;
    left: -50px;
    bottom: 0;
}
#logo {
    background-color: #b7dcc9;
}
#turnstile-widget {
    max-width: 300px;
    margin: 0 auto;
}
.margin-left {
    margin-left: -180%;
}
.card {
    border-radius: 30px;
    min-height: 640px;
    max-width: 650px;
}
input {
    color: #949c9c;
}
input:focus {
    box-shadow: 0px 4px 10px -6px;
}
.border-bottom {
    border-top: none;
    border-left: none;
    border-right: none;
    border-color: #bcbdbe;
}
::placeholder {
    color: #bcbdbe;
}
.sign-up {
    border: none;
    border-radius: 50px;
    background-color: #9dd6cd;
    color: #fff;
    font-size: 1.5rem;
    box-shadow: 0px 2px 6px 0.5px #bebebe;
    cursor: pointer;
    font-family: 'Playfair Display', serif;
}
a {
    font-size: 1rem;
}
.error {
    color: #f72415;
}
p {
    color: #bcbdbe;
}
li {
    color: #949c9c;
    font-size: 1.2rem;
}
li span {
    font-size: 1rem;
}
@media only screen and (min-height: 1200px) {
    .card {
        height: 800px;
    }
    .height {
        height: 1202px;
    }
}
@media only screen and (max-width: 650px) {
    .croc {
        display: none;
    }
}
</style>
